import { yup } from '@framework/validation';
import { fromPairs } from 'lodash';

export enum FormBuilderMetaFlags {
  /**
   * Flag meta per richiedere al FormBuilder di saltare l'impostazione
   * del valore di default dello schema.
   */
  SkipDefaultValue = 'formBuilder@skipDefaultValue',
  /**
   * Flag meta per richiede al FormBuilder di saltare l'applicazione
   * delle regole. È utilizzato quando lo schema ritornato dal Widget non
   * è uno schema "standard", oppure ve ne sono di addizionali
   */
  SkipValidationRules = 'formBuilder@SkipValidationRules',
  /**
   * Serializza le opzioni di un widget in un oggetto
   */
  SerializeSiblingOptions = 'formBuilder@SerializeSiblingOptions',
  /**
   * Ignora la regola "Required" per il widget
   */
  IgnoreRequired = 'formBuilder@IgnoreRequired',
  /**
   * Flag meta per richiedere al FormBuilder di saltare la configurazione
   * della label dello schema.
   */
  SkipLabel = 'formBuilder@SkipLabel',
}

declare module 'yup' {
  interface Schema {
    formBuilderFlags(
      // Permette di aggiungere flag meta personalizzati
      ...flag: Array<FormBuilderMetaFlags | `formBuilder@${string}`>
    ): this;
  }
}

yup.addMethod(
  yup.Schema as any,
  'formBuilderFlags',
  function (...flags: FormBuilderMetaFlags[]) {
    return this.meta(fromPairs(flags.map(flag => [flag, true])));
  },
);
